const mutations = {
  SET_OV_ACTIONS(state, { ovActions }) {
    state.ovActions = ovActions
  },
  SET_OV_DETAIL(state, { ovDetail }) {
    state.ovDetail = ovDetail
  }
}
export default mutations
